import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import McDonnellMillerContent from "./McDonnellMillerBoilerControlContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route
            path="/suppliers/mcdonnell-miller/boiler-controls"
            component={McDonnellMillerContent}
          />
          <Route path="/suppliers/mcdonnell-miller">
            <Redirect to="/suppliers/mcdonnell-miller/boiler-controls" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
